export default __webpack_public_path__ + "static/media/keto_cholesterol@3x.27965a17.jpg";